// add a document ready function
$(window).on('load', function() {

    $("[class^='lb-bundle-builder-select-item-']").click(function() {
        $(".lb-bundle-builder-flyout-container").addClass("lb-bundle-builder-flyout-container-open");
        $(".lb-bundle-builder-blur-bg").addClass("lb-bundle-builder-blur-bg-open");
    });

    $(".lb-bundle-builder-blur-bg, .lb-bundle-builder-flyout-select-item, .lb-bundle-builder-flyout-container-closer").click(function() {
        $(".lb-bundle-builder-flyout-container").removeClass("lb-bundle-builder-flyout-container-open");
        $(".lb-bundle-builder-blur-bg").removeClass("lb-bundle-builder-blur-bg-open");
    });

    for (let i = 1; i <= 8; i++) {
        $(`.lb-bundle-builder-select-item-${i}`).click(function() {
            for (let j = 1; j <= 8; j++) {
                if (i === j) {
                    $(`.lb-bundle-builder-item-holder-${j}`).addClass("lb-bundle-builder-item-holder-show");
                } else {
                    $(`.lb-bundle-builder-item-holder-${j}`).removeClass("lb-bundle-builder-item-holder-show");
                }
            }
            var inputTitle = $(`#bundbuilder${i}val`).attr('title');
            setFlyoutTitle(inputTitle);
        });
    }
});

// set the title of the flyout
function setFlyoutTitle(title) {
    $('#flyout-title').html(title);
}

// Function to initialize 'data-default-delivery' attributes once on page load
function initializeDefaultDelivery() {
    let messageElement = document.querySelector('.product-bundle__stock-message');
    let defaultDeliveryMessage = "";

    // Get default delivery message if the element exists
    if (messageElement) {
        defaultDeliveryMessage = messageElement.textContent.trim();
    }

    for (let i = 1; i <= 5; i++) {
        let preorderElem = document.getElementById(`preorder${i}`);
        if (preorderElem && !preorderElem.dataset.defaultDelivery) {
            preorderElem.dataset.defaultDelivery = defaultDeliveryMessage;
        }
    }
}

// Set default delivery message on page load
document.addEventListener('DOMContentLoaded', initializeDefaultDelivery);

function checkPreordersAndUpdate(addToCartText, preorderText) {
    let messageElement = document.querySelector('.product-bundle__stock-message');
    let foundText = null;
    let defaultDelivery = null;
    let button = document.getElementById('ProductSubmitButton-Bundle');
    let buttonTextSpan = button.querySelector('span');

    // Loop through preorder1 to preorder5 to find text
    for (let i = 1; i <= 5; i++) {
        let preorderElem = document.getElementById(`preorder${i}`);
        if (preorderElem && preorderElem.textContent.trim()) {
            foundText = preorderElem.textContent.trim();
            break;
        }
    }

    // If text is found in any of the paragraphs
    if (foundText) {
        messageElement.textContent = foundText;
        buttonTextSpan.textContent = preorderText;
    } else {
        // Check if any of the paragraphs has a 'data-default-delivery' attribute
        for (let i = 1; i <= 5; i++) {
            let preorderElem = document.getElementById(`preorder${i}`);
            if (preorderElem && preorderElem.dataset.defaultDelivery) {
                defaultDelivery = preorderElem.dataset.defaultDelivery;
                break;
            }
        }

        // If 'data-default-delivery' exists, update the message element
        if (defaultDelivery) {
            messageElement.textContent = defaultDelivery;
        } else {
            // If no 'data-default-delivery' attribute exists, clear the content of messageElement
            messageElement.textContent = "";
        }

        buttonTextSpan.textContent = addToCartText;
    }
}

